import React from "react";
import { Card, Flex } from "@jsq/ds/core";
import { Icon, type IconType } from "@jsq/ds/icons";
import {
  paymentPrefDisplayCardContainer,
  paymentPrefDisplayCardIcon,
} from "./styles_vanilla.css";

export type PaymentPrefDisplayCardContainerProps = {
  children: React.ReactNode;
  actionComponent?: React.ReactNode;
  iconType: IconType;
  isFullWidth?: boolean;
};

export const PaymentPrefDisplayCardContainer: React.FC<
  PaymentPrefDisplayCardContainerProps
> = ({
  children,
  actionComponent,
  iconType,
  isFullWidth,
}: PaymentPrefDisplayCardContainerProps) => {
  return (
    <Card className="PaymentPrefDisplayCard" padding="md">
      <Flex alignItems="flex-start" flexDirection="row" justifyContent="space-between">
        <Flex
          flexDirection="row"
          alignItems="flex-start"
          gap={20}
          className={isFullWidth ? paymentPrefDisplayCardContainer : ""}
        >
          <Icon type={iconType} size="x-large" className={paymentPrefDisplayCardIcon} />
          {children}
        </Flex>
        {actionComponent}
      </Flex>
    </Card>
  );
};
